import { ButtonBase, Divider } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;

  h3 {
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: var(--color-navy-blue);
    font-family: Sora, sans-serif;
  }

  p {
    font-size: 14px;
    line-height: 18px;
    color: var(--color-alba-grandeza);
    font-family: Sora, sans-serif;
  }
`;

export const ComplementItem = styled(ButtonBase)`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: var(--color-navy-blue);
  font-family: Sora, sans-serif;
  padding: 12px 8px;

  .MuiRadio-colorSecondary.Mui-checked {
    color: var(--color-blue) !important;
  }

  .MuiIconButton-colorSecondary:hover {
    background-color: #329bfc1a;
  }

  .PrivateSwitchBase-root-39 {
    padding: 0;
  }

  .informations {
    display: -webkit-flex;
    flex-direction: column;
    align-items: flex-start;
    flex-grow: 1;
    gap: 4px;

    .number_of_slices {
      color: var(--color-alba-grandeza);
      font-size: 14px;
    }

    .price {
      display: flex;
      gap: 4px;

      .new {
        color: var(--color-blue);
        font-weight: 600;
      }

      .old {
        text-decoration: line-through;
        color: var(--color-alba-grandeza);
        font-size: 14px;
      }
    }
  }

  p {
    font-size: 16px;
    line-height: 20px;
    user-select: none;
    color: var(--color-navy-blue);
    font-family: Sora, sans-serif;
  }

  .price {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: var(--color-alba-grandeza);
    font-family: Sora, sans-serif;
  }
`;

export const CustomDivider = styled(Divider)`
  width: 100%;
  background: var(--color-gray-900);
`;
